(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldDatepicker', fbFieldDatepickerDirective);

    function fbFieldDatepickerDirective($timeout, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element:'=',
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldDatepicker',
            controller: fbFieldDatepickerDirectiveCtrl,
            controllerAs: 'fieldCtrl',
            bindToController: true,
            require: 'ngModel',
            link: function(scope, elem, link, ngModelCtrl) {
                var input = elem.find('input');
                if (lodash.get(scope.fieldCtrl, 'element.options.disableInput', false) === true) {
                    input.attr("autocomplete", "off");

                    input.on('click', function() {
                        if (input.find('.k-picker-wrap').hasClass('k-state-active')) {
                            scope.fieldCtrl.element.callback.close();
                        } else {
                            scope.fieldCtrl.element.callback.open();
                        }
                    })
                    $timeout(function() {
                        input.attr("readonly", "readonly");
                    });
                }

                scope.fieldCtrl.commitValue = function(value) {
                    ngModelCtrl.$setViewValue(value);
                }


                ngModelCtrl.$render = function() {
                    scope.current_model = ngModelCtrl.$viewValue;
//                    lodash.set(scope.current_model, ngModelCtrl.$viewValue);
                    if (scope.fieldCtrl.element.callback) {
                        scope.fieldCtrl.element.callback.value(scope.current_model);
                    }
                };

                ngModelCtrl.$parsers.push(function(viewValue) {
                    if (!viewValue) return null
                    if (!!scope.fieldCtrl.parse_format) {
                        return moment(viewValue).format(scope.fieldCtrl.parse_format);
                    }
                    return viewValue;
                });


            }
        };
    }

    function fbFieldDatepickerDirectiveCtrl(lodash, FormBuilderService, $scope) {
        var fieldCtrl = this;
        var formIdentifier = '';

        this.$onInit = function() {
            fieldCtrl.current_model = '';

            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, fieldCtrl);

            fieldCtrl.onEventTrigger = fieldCtrl.pageData.eventsService.onEventTrigger.bind(fieldCtrl);
            fieldCtrl.getModelOptions = fieldCtrl.pageData.eventsService.getModelOptions.bind(fieldCtrl);

            fieldCtrl.kendo_parse_format = lodash.get(fieldCtrl.element, 'options.kendo_parse_format', 'dd/MM/yyyy');
            fieldCtrl.parse_format = lodash.get(fieldCtrl.element, 'options.parse_format', null);

            fieldCtrl.dateOptions = angular.merge({
                    format: fieldCtrl.kendo_parse_format,
                    change: function(value) {
                        fieldCtrl.commitValue(value.sender._value);
                        fieldCtrl.onEventTrigger('onChange');
                    },
                    month: {
                        empty: '<div style="color:\\#ccc;line-height: 1.833em">#= data.value #</div>'
                    }
                },
                lodash.get(fieldCtrl.element,'attr.datePickerOptions',{}),
                generateOptions()
            );
        }

        function generateOptions() {
            var option = {};
            if (lodash.has(fieldCtrl.element, 'options.max')) {
                var now = lodash.get(fieldCtrl.element, 'options.max.now');
                if (now) {
                    option.max = new Date();
                } else {
                    var maxObj = fieldCtrl.element.options.max;
                    option.max = new Date(maxObj.year, maxObj.month - 1, maxObj.day);
                }
            }

            if (lodash.has(fieldCtrl.element, 'options.min')) {
                var now = lodash.get(fieldCtrl.element, 'options.min.now');
                if (now) {
                    option.min = new Date();
                } else {
                    var minObj = fieldCtrl.element.options.min;
                    option.min = new Date(minObj.year, minObj.month - 1, minObj.day);
                }
            }

            return option;
        }

    }
})();